import React from "react";
import { Helmet } from "react-helmet-async";
import Title from "../../components/title/title.component";
import { Trans, useTranslation } from "react-i18next";

import { StyledContainer } from "../../components/styles/styled-container";
import { StaticInfoContent, StaticInfoWrapper } from "../../components/static-information/styled-static-info";
import { StyledBlockTitle, StyledList, StyledParagraph } from "../../components/styles/styled-document-elemets";
import { StyledContainerArticle } from "../../components/styles/styled-content-article";
import AlertMessage from "../../components/alert/alert.component";
import { helmetHtmlByLang } from "../../utils/consts.util";
import CustomLink from "../../components/customLink/CustomLink";
import { cleanCanonicalUrl } from "../../utils/links.utils";

const ClientManual = () => {
  const { t } = useTranslation("clientManual");

  return (
    <StyledContainer>
      <Helmet>
        <title>{t("meta.title")}</title>
        <meta
          name="description"
          content={t("meta.description")}
        />
        <link rel="canonical" href={cleanCanonicalUrl()} />
        <link rel="alternate" href={"https://" + window.location.hostname + "/client-manual"} hrefLang={helmetHtmlByLang.ru} />
        <link rel="alternate" href={"https://" + window.location.hostname + "/ua/client-manual"} hrefLang={helmetHtmlByLang.ua} />
        <link rel="alternate" href={"https://" + window.location.hostname + "/en/client-manual"} hrefLang={helmetHtmlByLang.en} />
      </Helmet>
      <StaticInfoWrapper>
        <Title
          as="h1"
          title={t("header.title")}
          description={t("header.subTitle")}
        />
        <StaticInfoContent width="800">
          <StyledContainerArticle>
            <span>{t("contentArticle.title")}</span>
            <StyledBlockTitle>
              <a href="#title1">{t("1.title")}</a>
            </StyledBlockTitle>
            <StyledList as="ol" countStart="1">
              <li><a href="#ca1_1">{t("contentArticle.1_1")}</a></li>
              <li><a href="#ca1_2">{t("contentArticle.1_2")}</a></li>
            </StyledList>
            <StyledBlockTitle>
              <a href="#title2">{t("2.title")}</a>
            </StyledBlockTitle>
            <StyledList as="ol" countStart="2">
              <li><a href="#ca2_1">{t("2.2_1.title")}</a></li>
              <li><a href="#ca2_2">{t("2.2_2.title")}</a></li>
              <li><a href="#ca2_3">{t("2.2_3.title")}</a></li>
              <li><a href="#ca2_4">{t("2.2_4.title")}</a></li>
            </StyledList>
            <StyledBlockTitle>
              <a href="#title3">{t("3.title")}</a>
            </StyledBlockTitle>
            <StyledList as="ol" countStart="3">
              <li><a href="#ca3_1">{t("3.3_1.title")}</a></li>
              <li><a href="#ca3_2">{t("3.3_2.title")}</a></li>
            </StyledList>
            <StyledBlockTitle>
              <a href="#title4">{t("4.title")}</a>
            </StyledBlockTitle>
            <StyledList as="ol" countStart="4">
              <li><a href="#ca4_1">{t("4.4_1.title")}</a></li>
              <li><a href="#ca4_2">{t("4.4_2.title")}</a></li>
              <li><a href="#ca4_3">{t("4.4_3.title")}</a></li>
            </StyledList>
            <StyledBlockTitle>
              <a href="#title5">{t("5.title")}</a>
            </StyledBlockTitle>
            <StyledList as="ol" countStart="5">
              <li><a href="#ca5_1">{t("5.5_1.title")}</a></li>
              <li><a href="#ca5_2">{t("5.5_2.title")}</a></li>
            </StyledList>
            <StyledBlockTitle>
              <a href="#title6">{t("6.title")}</a>
            </StyledBlockTitle>
            <StyledBlockTitle>
              <a href="#title7">{t("7.title")}</a>
            </StyledBlockTitle>
            <StyledList as="ol" countStart="6">
              <li><a href="#ca7_1">{t("7.7_1.title")}</a></li>
              <li><a href="#ca7_2">{t("7.7_2.title")}</a></li>
              <li><a href="#ca7_3">{t("7.7_3.title")}</a></li>
              <li><a href="#ca7_4">{t("7.7_4.title")}</a></li>
              <li><a href="#ca7_5">{t("7.7_5.title")}</a></li>
              <li><a href="#ca7_6">{t("7.7_6.title")}</a></li>
            </StyledList>
          </StyledContainerArticle>
          <StyledBlockTitle id="title1">
            {t("1.title")}
          </StyledBlockTitle>
          <StyledParagraph>
            <b>{t("1.p")}</b>
          </StyledParagraph>
          <StyledList as="ol" countStart="1">
            <li id="ca1_1">
              <StyledParagraph>
                <Trans components={{ CustomLink: <CustomLink /> }}>
                  {t("1.1_1")}
                </Trans>
              </StyledParagraph>
            </li>
            <li id="ca1_2">
              <StyledParagraph>
                <Trans components={{ CustomLink: <CustomLink /> }}>
                  {t("1.1_2.p1")}
                </Trans>
              </StyledParagraph>
              <StyledList>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("1.1_2.list.p1")}
                  </Trans>
                </li>
                <li>
                  {t("1.1_2.list.p2")}
                </li>
                <li>
                  {t("1.1_2.list.p3")}
                </li>
                <li>
                  {t("1.1_2.list.p4")}
                </li>
                <li>
                  {t("1.1_2.list.p5")}
                </li>
                <li>
                  {t("1.1_2.list.p6")}
                </li>
                <li>
                  {t("1.1_2.list.p7")}
                </li>
              </StyledList>
              <StyledParagraph>
                {t("1.1_2.p2")}
              </StyledParagraph>
            </li>
          </StyledList>
          <StyledBlockTitle id="title2">
            {t("2.title")}
          </StyledBlockTitle>
          <StyledList as="ol" countStart="2">
            <li id="ca2_1">
              <b>{t("2.2_1.title")}</b>
              <StyledList listStyle="disc">
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("2.2_1.list.p1")}
                  </Trans>
                </li>
                <li>
                  {t("2.2_1.list.p2")}
                </li>
              </StyledList>
            </li>
            <li id="ca2_2">
              <b>{t("2.2_2.title")}</b>
              <StyledList listStyle="disc">
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("2.2_2.list.p1")}
                  </Trans>
                </li>
                <li>
                  {t("2.2_2.list.p2")}
                </li>
                <li>
                  {t("2.2_2.list.p3")}
                </li>
                <li>
                  {t("2.2_2.list.p4")}
                </li>
              </StyledList>
              <StyledParagraph>
                {t("2.2_2.p")}
              </StyledParagraph>
            </li>
            <li id="ca2_3">
              <b>{t("2.2_3.title")}</b>
              <StyledList listStyle="disc">
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("2.2_3.list.p1")}
                  </Trans>
                </li>
                <li>
                  {t("2.2_3.list.p2")}
                </li>
                <li>
                  {t("2.2_3.list.p3")}
                </li>
                <li>
                  {t("2.2_3.list.p4")}
                </li>
              </StyledList>
              <StyledParagraph>
                <Trans components={{ a: <a /> }}>
                  {t("2.2_3.p")}
                </Trans>
              </StyledParagraph>
            </li>
            <li id="ca2_4">
              <b>{t("2.2_4.title")}</b>
              <StyledList listStyle="disc">
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("2.2_4.list.p1")}
                  </Trans>
                </li>
                <li>
                  {t("2.2_4.list.p2")}
                </li>
                <li>
                  {t("2.2_4.list.p3")}
                </li>
                <li>
                  {t("2.2_4.list.p4")}
                </li>
                <li>
                  {t("2.2_4.list.p5")}
                </li>
                <li>
                  {t("2.2_4.list.p6")}
                </li>
                <li>
                  {t("2.2_4.list.p7")}
                </li>
              </StyledList>
              <StyledParagraph>
                <Trans components={{ a: <a /> }}>
                  {t("2.2_4.p")}
                </Trans>
              </StyledParagraph>
            </li>
          </StyledList>
          <StyledBlockTitle id="title3">
            {t("3.title")}
          </StyledBlockTitle>
          <StyledList as="ol" countStart="3">
            <li id="ca3_1">
              <b>{t("3.3_1.title")}</b>
              <StyledParagraph>
                {t("3.3_1.p1")}
              </StyledParagraph>
              <StyledList listStyle="disc">
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("3.3_1.list.p1")}
                  </Trans>
                </li>
                <li>
                  {t("3.3_1.list.p2")}
                </li>
                <li>
                  {t("3.3_1.list.p3")}
                </li>
                <li>
                  {t("3.3_1.list.p4")}
                </li>
                <li>
                  {t("3.3_1.list.p5")}
                </li>
                <li>
                  {t("3.3_1.list.p6")}
                </li>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("3.3_1.list.p7")}
                  </Trans>
                </li>
                <StyledParagraph>
                  <Trans components={{ a: <a /> }}>
                    {t("3.3_1.list.p7_desc")}
                  </Trans>
                </StyledParagraph>
                <li>
                  {t("3.3_1.list.p8")}
                </li>
                <li>
                  {t("3.3_1.list.p9")}
                </li>
                <li>
                  {t("3.3_1.list.p10")}
                </li>
                <li>
                  {t("3.3_1.list.p11")}
                </li>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("3.3_1.list.p12")}
                  </Trans>
                </li>
              </StyledList>
            </li>
            <li id="ca3_2">
              <b>{t("3.3_2.title")}</b>
              <StyledParagraph>
                <Trans components={{ CustomLink: <CustomLink /> }}>
                  {t("3.3_2.p1")}
                </Trans>
              </StyledParagraph>
              <StyledParagraph>
                {t("3.3_2.p2")}
              </StyledParagraph>
              <StyledList listStyle="disc">
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("3.3_2.list.p1")}
                  </Trans>
                </li>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("3.3_2.list.p2")}
                  </Trans>
                </li>
                <li>
                  {t("3.3_2.list.p3")}
                </li>
                <li>
                  {t("3.3_2.list.p4")}
                </li>
                <li>
                  {t("3.3_2.list.p5")}
                </li>
                <li>
                  {t("3.3_2.list.p6")}
                </li>
                <li>
                  {t("3.3_2.list.p7")}
                </li>
              </StyledList>
              <AlertMessage
                type="warning"
                message={t("3.3_2.alert")}
              />
            </li>
          </StyledList>
          <StyledBlockTitle id="title4">
            {t("4.title")}
          </StyledBlockTitle>
          <StyledList as="ol" countStart="4">
            <li id="ca4_1">
              <b>{t("4.4_1.title")}</b>
              <StyledParagraph id="paymentDetails">
                {t("4.4_1.p1")}
              </StyledParagraph>
              <StyledList listStyle="disc">
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("4.4_1.list.p1")}
                  </Trans>
                </li>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("4.4_1.list.p2")}
                  </Trans>
                </li>
                <li>
                  {t("4.4_1.list.p3")}
                </li>
                <li>
                  {t("4.4_1.list.p4")}
                </li>
                <li>
                  {t("4.4_1.list.p5")}
                </li>
                <li>
                  {t("4.4_1.list.p6")}
                </li>
                <li>
                  {t("4.4_1.list.p7")}
                </li>
              </StyledList>
              <StyledParagraph>
                {t("4.4_1.p2")}
              </StyledParagraph>
            </li>
            <li id="ca4_2">
              <b>{t("4.4_2.title")}</b>
              <StyledList listStyle="disc">
                <StyledParagraph>{t("4.4_2.list.title")}</StyledParagraph>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("4.4_2.list.p1")}
                  </Trans>
                </li>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("4.4_2.list.p2")}
                  </Trans>
                </li>
                <li>
                  {t("4.4_2.list.p3")}
                </li>
                <li>
                  {t("4.4_2.list.p4")}
                </li>
                <li>
                  {t("4.4_2.list.p5")}
                </li>
              </StyledList>
            </li>
            <li id="ca4_3">
              <b>{t("4.4_3.title")}</b>
              <StyledParagraph>
                {t("4.4_3.p1")}
              </StyledParagraph>
              <StyledList listStyle="disc">
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("4.4_3.list.p1")}
                  </Trans>
                </li>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("4.4_3.list.p2")}
                  </Trans>
                </li>
                <li>
                  {t("4.4_3.list.p3")}
                </li>
                <li>
                  {t("4.4_3.list.p4")}
                </li>
                <li>
                  {t("4.4_3.list.p5")}
                </li>
              </StyledList>
              <StyledParagraph>
                {t("4.4_3.p2")}
              </StyledParagraph>
            </li>
          </StyledList>
          <StyledBlockTitle id="title5">
            {t("5.title")}
          </StyledBlockTitle>
          <StyledList as="ol" countStart="5">
            <li id="ca5_1">
              <b>{t("5.5_1.title")}</b>
              <StyledParagraph>
                <Trans components={{ CustomLink: <CustomLink /> }}>
                  {t("5.5_1.p1")}
                </Trans>
              </StyledParagraph>
              <StyledList listStyle="disc">
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("5.5_1.list.p1")}
                  </Trans>
                </li>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("5.5_1.list.p2")}
                  </Trans>
                </li>
                <li>
                  {t("5.5_1.list.p3")}
                </li>
                <li>
                  {t("5.5_1.list.p4")}
                </li>
                <li>
                  {t("5.5_1.list.p5")}
                </li>
                <li>
                  {t("5.5_1.list.p6")}
                </li>
                <li>
                  {t("5.5_1.list.p7")}
                </li>
                <StyledParagraph>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("5.5_1.list.p7_desc")}
                  </Trans>
                </StyledParagraph>
                <li>
                  {t("5.5_1.list.p8")}
                </li>
              </StyledList>
              <StyledParagraph>
                {t("5.5_1.p2")}
              </StyledParagraph>
            </li>
            <li id="ca5_2">
              <b>{t("5.5_2.title")}</b>
              <StyledParagraph>
                <Trans components={{ CustomLink: <CustomLink /> }}>
                  {t("5.5_2.p1")}
                </Trans>
              </StyledParagraph>
              <StyledList listStyle="disc">
                <StyledParagraph>{t("5.5_2.list.title")}</StyledParagraph>
                <li>
                  {t("5.5_2.list.p1")}
                </li>
                <li>
                  {t("5.5_2.list.p2")}
                </li>
                <li>
                  {t("5.5_2.list.p3")}
                </li>
                <li>
                  {t("5.5_2.list.p4")}
                </li>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("5.5_2.list.p5")}
                  </Trans>
                </li>
                <li>
                  {t("5.5_2.list.p6")}
                </li>
              </StyledList>
              <StyledParagraph>
                {t("5.5_1.p2")}
              </StyledParagraph>
            </li>
          </StyledList>
          <StyledBlockTitle id="title6">
            {t("6.title")}
          </StyledBlockTitle>
          <StyledList>
            <StyledParagraph id="ca6_1">{t("6.list.title")}</StyledParagraph>
            <li>
              <Trans components={{ CustomLink: <CustomLink /> }}>
                {t("6.list.p1")}
              </Trans>
            </li>
            <li>
              {t("6.list.p2")}
            </li>
            <li>
              {t("6.list.p3")}
            </li>
            <li>
              {t("6.list.p4")}
            </li>
            <li>
              {t("6.list.p5")}
            </li>
            <li>
              {t("6.list.p6")}
            </li>
            <li>
              {t("6.list.p7")}
            </li>
          </StyledList>
          <StyledParagraph>
            {t("6.p")}
          </StyledParagraph>
          <StyledBlockTitle id="title7">
            {t("7.title")}
          </StyledBlockTitle>
          <StyledList as="ol" countStart="7">
            <li id="ca7_1">
              <b>{t("7.7_1.title")}</b>
              <StyledParagraph>
                {t("7.7_1.p1")}
              </StyledParagraph>
              <StyledList listStyle="disc">
                <StyledParagraph>{t("7.7_1.list.title")}</StyledParagraph>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("7.7_1.list.p1")}
                  </Trans>
                </li>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("7.7_1.list.p2")}
                  </Trans>
                </li>
                <li>
                  {t("7.7_1.list.p3")}
                </li>
                <li>
                  {t("7.7_1.list.p4")}
                </li>
                <li>
                  {t("7.7_1.list.p5")}
                </li>
                <li>
                  {t("7.7_1.list.p6")}
                </li>
                <li>
                  {t("7.7_1.list.p7")}
                </li>
              </StyledList>
              <StyledParagraph id="twoFactor">
                {t("7.7_1.p2")}
              </StyledParagraph>
            </li>
            <li id="ca7_2">
              <b>{t("7.7_2.title")}</b>
              <StyledList listStyle="disc">
                <StyledParagraph>{t("7.7_2.list.title")}</StyledParagraph>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("7.7_2.list.p1")}
                  </Trans>
                </li>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("7.7_2.list.p2")}
                  </Trans>
                </li>
                <li>
                  {t("7.7_2.list.p3")}
                </li>
                <li>
                  {t("7.7_2.list.p4")}
                </li>
                <li>
                  <Trans components={{ a: <a /> }}>
                    {t("7.7_2.list.p5")}
                  </Trans>
                </li>
                <StyledParagraph>{t("7.7_2.list.p5_desc")}</StyledParagraph>
                <li>
                  {t("7.7_2.list.p6")}
                </li>
                <li>
                  {t("7.7_2.list.p7")}
                </li>
                <li>
                  {t("7.7_2.list.p8")}
                </li>
                <li>
                  {t("7.7_2.list.p9")}
                </li>
              </StyledList>
            </li>
            <li id="ca7_3">
              <b>{t("7.7_3.title")}</b>
              <StyledParagraph>
                {t("7.7_3.p1")}
              </StyledParagraph>
              <StyledList listStyle="disc">
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("7.7_3.list.p1")}
                  </Trans>
                </li>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("7.7_3.list.p2")}
                  </Trans>
                </li>
                <li>
                  {t("7.7_3.list.p3")}
                </li>
                <li>
                  {t("7.7_3.list.p4")}
                </li>
                <li>
                  {t("7.7_3.list.p5")}
                </li>
                <li>
                  {t("7.7_3.list.p6")}
                </li>
              </StyledList>
              <StyledParagraph>
                {t("7.7_3.p2")}
              </StyledParagraph>
            </li>
            <li id="ca7_4">
              <b>{t("7.7_4.title")}</b>
              <StyledParagraph>
                {t("7.7_4.p1")}
              </StyledParagraph>
              <StyledList listStyle="disc">
                <StyledParagraph>
                  {t("7.7_4.list.title")}
                </StyledParagraph>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("7.7_4.list.p1")}
                  </Trans>
                </li>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("7.7_4.list.p2")}
                  </Trans>
                </li>
                <li>
                  {t("7.7_4.list.p3")}
                </li>
                <li>
                  {t("7.7_4.list.p4")}
                </li>
                <li>
                  {t("7.7_4.list.p5")}
                </li>
              </StyledList>
            </li>
            <li id="ca7_5">
              <b>{t("7.7_5.title")}</b>
              <StyledList listStyle="disc">
                <StyledParagraph>
                  {t("7.7_5.list.title")}
                </StyledParagraph>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("7.7_5.list.p1")}
                  </Trans>
                </li>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("7.7_5.list.p2")}
                  </Trans>
                </li>
                <li>
                  {t("7.7_5.list.p3")}
                </li>
                <li>
                  {t("7.7_5.list.p4")}
                </li>
              </StyledList>
              <StyledParagraph>
                {t("7.7_5.p")}
              </StyledParagraph>
            </li>
            <li id="ca7_6">
              <b>{t("7.7_6.title")}</b>
              <StyledParagraph>
                {t("7.7_6.p1")}
              </StyledParagraph>
              <StyledList listStyle="disc">
                <li>
                  {t("7.7_6.list.p1")}
                </li>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("7.7_6.list.p2")}
                  </Trans>
                </li>
                <li>
                  <Trans components={{ CustomLink: <CustomLink /> }}>
                    {t("7.7_6.list.p3")}
                  </Trans>
                </li>
                <li>
                  {t("7.7_6.list.p4")}
                </li>
                <li>
                  {t("7.7_6.list.p5")}
                </li>
                <li>
                  {t("7.7_6.list.p6")}
                </li>
                <li>
                  {t("7.7_6.list.p7")}
                </li>
              </StyledList>
              <StyledParagraph>
                {t("7.7_6.p2")}
              </StyledParagraph>
            </li>
          </StyledList>
        </StaticInfoContent>
      </StaticInfoWrapper>
    </StyledContainer>
  );
};

export default React.memo(ClientManual);